import * as React from 'react';
import { Hidden } from '@material-ui/core';
import { Title } from '../../components/title/title';
import Logo from '../../assets/validacao.svg';
import * as Sebrae from '@sebrae/react-core';
import {
  BaSeHeading5,
  BaSeSmall1,
  BaSeInput,
  BaSeButton,
  BaSeTheme,
} from '@base/react';
import { BodyContent, InputCode, TextContent } from './validacao-styled';

const ROUTE_RESULTADO = '/resultado';

export const Validacao = () => {
  const [codigoAutenticacao, setCodigoAutenticacao] = React.useState('');
  const [disabled, setDisabled] = React.useState(true);
  const { azulSebrae36, cinzaSebrae45 } = BaSeTheme.colors.institucionais;

  const handleChange = (event) => {
    setCodigoAutenticacao(event);
    if (event !== '') {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };
  const { navigateTo } = Sebrae.useRouter();

  return (
    <div style={{ height: '100%' }}>
      <Title
        titulo="Cursos Sebrae"
        subtitulo="Validação de certificado"
        paddingContent="16px"
        paddingSubtitulo="16px"
      />
      <BodyContent>
        <div>
          <TextContent>
            <BaSeHeading5 color={azulSebrae36}>
              Digite o código do certificado no formulário abaixo para verificar
              sua autencidade.
            </BaSeHeading5>
            <BaSeSmall1 color={cinzaSebrae45}>
              Atenção: digite corretamente as letras maiúsculas e minúsculas,
              pois isso interfere no reconhecimento do código.
            </BaSeSmall1>
          </TextContent>
          <InputCode>
            <BaSeInput
              label="Código do certificado"
              subLabel=" Obrigatório"
              onChange={handleChange}
              placeholder="Digite o código de validação do certificado"
              size="medium"
              typeInput="text"
              value={codigoAutenticacao}
              width="100%"
            />
            <BaSeButton
              isDisabled={disabled}
              buttonType="button"
              onClick={() =>
                navigateTo(`${ROUTE_RESULTADO}/${codigoAutenticacao}`)
              }
              size="medium"
              type="primary"
              value="Validar"
              width="100px"
            />
          </InputCode>
        </div>
        <Hidden smDown>
          <figure>
            <img src={Logo} style={{ width: '400px' }} alt="" />
          </figure>
        </Hidden>
      </BodyContent>
    </div>
  );
};
